export default {
    url: '/power_gain',
    template: require('./view.html'),
    data: {
        title: 'Season Power Gain',
        role: 'rating_arena',
        priority: 804,
    },
    reloadOnSearch: false,
};
